import { TextAa, Minus, Plus } from "@phosphor-icons/react";
import { useFontSize } from "../hooks/useFontSize";

export default function FontSizeControl() {
  const { fontSize, increase, decrease, isDefault } = useFontSize();

  return (
    <div className="flex items-center gap-1 bg-white/5 border border-white/10 rounded-xl px-2 py-1">
      <TextAa size={16} className="text-white/40 mr-1" />
      <button
        onClick={decrease}
        className="text-white/60 hover:text-white p-1 cursor-pointer"
        title="Yazıyı küçült"
      >
        <Minus size={14} weight="bold" />
      </button>
      <span className="text-xs text-white/50 w-5 text-center">
        {isDefault ? "" : fontSize}
      </span>
      <button
        onClick={increase}
        className="text-white/60 hover:text-white p-1 cursor-pointer"
        title="Yazıyı büyüt"
      >
        <Plus size={14} weight="bold" />
      </button>
    </div>
  );
}
